import { AUTHENTICATION_TOKEN, REFRESH_TOKEN } from '../constants/common';
import { deleteLocalStorage, getToken, removeCookie, setToken } from '../utils/cookie';

export const requestInterceptor = (request) => {
  const user = JSON.parse(localStorage.getItem('persist:user'));
  const organization = user?.userOrganizationId?.slice(1, -1);
  const authToken = getToken(AUTHENTICATION_TOKEN);

  if (authToken) {
    request.headers['Authorization'] = authToken;
  }
  if (organization) {
    request.headers['X-Organization'] = organization;
  }
  return request;
};

export const requestErrorInterceptor = (error) => {
  throw error.response || error;
};

export const responseErrorInterceptor = async (error) => {
  const originalRequest = error.config;
  if (error?.response?.data?.message === 'EXPIRED_TOKEN' && !originalRequest._retry) {
    originalRequest._retry = true;

    try {
      const response = await axios.post(`${config.PROXY_URL}/onedoc_backend/v1/auth/refresh`, {
        refresh_token: getToken(REFRESH_TOKEN),
      });
      const { data } = response;
      const { access_token } = data?.data;
      setToken(AUTHENTICATION_TOKEN, access_token);
      originalRequest.headers['Authorization'] = access_token;
      return clientService(originalRequest);
    } catch (refreshError) {
      localStorage.removeItem('persist:user');
      deleteLocalStorage();
      removeCookie();
      window.location.href = '/login';
      return Promise.reject(refreshError);
    }
  }

  // Handle other error cases
  if (error?.response?.status === 401) {
    localStorage.removeItem('persist:user');
    deleteLocalStorage();
    removeCookie();
    window.location.href = '/login';
  }

  if (error?.response?.status === 412) {
    deleteLocalStorage();
    removeCookie();
  }

  throw error.response?.data || error;
};

export const responseInterceptor = (response) => response.data || response;
